import React, { useEffect } from "react";
import { useState } from "react";
import FullScreenModal from "./FullScreenModal";
import { CapabilityCard, CapabilityCard2 } from "../services/Capabilities2";
import useScreenSize from "../../hooks/useScreenSize";
import CarouselContainer from "../reusable/CarouselContainer";

const IndustryDetailSection = ({ dataList, bg }) => {
  const size = useScreenSize();
  const isSmall = size == "sm" || size == "md";

  const [selectedItem, setselectedItem] = useState("");
  const [currentBlog, setcurrentBlog] = useState({});
  const [modalConfig, setmodalConfig] = useState({
    open: false,
    children: <></>,
  });

  useEffect(() => {
    if (!!size) {
      if (isSmall) {
        setselectedItem("");
      } else {
        setselectedItem(dataList[0]["key"]);
      }
    }
  }, [isSmall, size]);

  useEffect(() => {
    const contentIdx = dataList.findIndex(item => item.key === selectedItem);
    if (contentIdx != -1) {
      let selected = dataList[contentIdx];
      setcurrentBlog({ title: selected.title, subtitle: selected.text, img: selected.img });

      if (isSmall) {
        setmodalConfig({
          open: true,
          children: <CapabilityCard title={selected.title} subtitle={selected.text} hideTitle />,
        });
      }
    }
  }, [selectedItem, isSmall]);

  return (
    <>
      <section className={`${bg ? bg : "bg-slate-700"} flex flex-col  `}>
        <h2 className=" text-4xl  mb-[50px] font-semibold  text-white">Technology as a Catalyst for Change</h2>
        <div className="flex justify-between mt-2 w-[100%] mb-8 ">
          <div className="w-[100%] md:w-[50%] text-black cursor-pointer  ">
            {isSmall ? (
              <CarouselContainer>
                {dataList.map(capability => {
                  return (
                    <div key={capability.key} className=" pt-4 px-4 w-[90%] mx-auto">
                      <CapabilityCard2
                        key={capability.key}
                        title={capability.key}
                        subtitle={capability.title}
                        img={capability.img}
                        onHoverStart={() => setselectedItem(capability.key)}
                        activeItem={selectedItem}
                        isSmall={isSmall}
                      />
                    </div>
                  );
                })}
              </CarouselContainer>
            ) : (
              dataList.map(capability => (
                <CapabilityCard2
                  key={capability.key}
                  title={capability.key}
                  subtitle={capability.title}
                  img={capability.img}
                  onHoverStart={() => setselectedItem(capability.key)}
                  activeItem={selectedItem}
                  isSmall={isSmall}
                  hideSubtitle
                />
              ))
            )}
          </div>
          <div className="hidden md:block md:w-[45%] ">
            <div>
              {selectedItem && currentBlog?.title ? (
                <CapabilityCard title={currentBlog.title} subtitle={currentBlog.subtitle} img={currentBlog.img} hideTitle />
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </section>
      <FullScreenModal
        isOpen={modalConfig.open}
        onClose={() => {
          setmodalConfig(() => ({ open: false, children: <></> }));
          setselectedItem("");
        }}
        styleClass="[&>div]:!bg-[#051747]"
      >
        {modalConfig.children}
      </FullScreenModal>
    </>
  );
};

export default IndustryDetailSection;
